import { QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import { queryClient } from "hub/src/api/client/query-client";
import type { PlatformSpecificQueryClientProvider } from "./types";

export const setupWebPlatformQueryClientProvider = () => {
  const WebPlatformQueryClientProvider: PlatformSpecificQueryClientProvider = (
    props,
  ) => {
    return (
      <QueryClientProvider client={queryClient}>
        {props.children}
      </QueryClientProvider>
    );
  };

  return WebPlatformQueryClientProvider;
};
